export const createFileText = fileUrl => {
  const fileUrlSegments = fileUrl.split('/')

  if (fileUrlSegments.length > 0) {
    return fileUrlSegments[fileUrlSegments.length - 1]
  } else {
    return fileUrlSegments
  }
}
